import { WINDOW } from '@ng-toolkit/universal';
import { Component, OnInit , Inject} from '@angular/core';
import * as $ from 'jquery';
import { Title, Meta, TransferState, makeStateKey } from '@angular/platform-browser';
import { Article } from '../../models/Article';
import { ArticlesService } from '../../services/articles.service';

const STATE_KEY_USERS = makeStateKey('users');

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

    constructor(@Inject(WINDOW) private window: Window, 
        private title: Title,
        private meta: Meta,
        private articlesService: ArticlesService, private state: TransferState
    ) {

        this.title.setTitle('AirOnline.pl - system rezerwacji i wyszukiwarka  biletów lotniczych');

        this.meta.addTag({
            name: 'description',
            content: 'Operatorem systemu rezerwacji i wyszukiwarki biletów lotniczych Aironline.pl jest biuro podróży Polish Travel Quo Vadis z siedzibą w Warszawie działające od 1990 roku. Jesteśmy akredytowanym agentem IATA.'
        });

        this.meta.addTag({
            name: 'author',
            content: 'Polish Travel Quo Vadis - Dział bilety lotnicze'
        });

        this.meta.addTag({
            name: 'keywords',
            content: 'bilety, lotnicze, wiadomości, news, wyszukiwarka'
        });

    }

    isLoading = true;

    responseArticlesData: Array<Article>  = [];

    ngOnInit() {

        this.isLoading = true;
        this.responseArticlesData = this.state.get(STATE_KEY_USERS, <any>[]);

        if (this.responseArticlesData.length === 0) {
          this.articlesService.getArticles(0, 6).subscribe(data => {
            this.isLoading = false;
            this.responseArticlesData = data;
            this.state.set(STATE_KEY_USERS, <any>data);
            // console.log(data);
          });
        }    else {
          this.isLoading = false;
        }


        $(document).ready(function () {
            var itemsMainDiv = ('.MultiCarousel');
            var itemsDiv = ('.MultiCarousel-inner');
            var itemWidth = 0;

            $('.leftLst, .rightLst').click(function () {
                var condition = $(this).hasClass('leftLst');
                if (condition)
                    click(0, this);
                else
                    click(1, this)
            });

            ResCarouselSize();

            $(this.window).resize(function () {
                ResCarouselSize();
            });

            //this function define the size of the items
            function ResCarouselSize() {
                var incno = 0;
                var dataItems = ('data-items');
                var itemClass = ('.item');
                var id = 0;

                var btnParentSb = '';
                var itemsSplit: any;
                var sampwidth = $(itemsMainDiv).width();
                var bodyWidth = $('body').width();
                $(itemsDiv).each(function () {
                    id = id + 1;
                    var itemNumbers = $(this).find(itemClass).length;
                    btnParentSb = $(this).parent().attr(dataItems);
                    itemsSplit = btnParentSb.split(',');
                    $(this).parent().attr('id', 'MultiCarousel' + id);


                    if (bodyWidth >= 1200) {
                        incno = itemsSplit[3];
                        itemWidth = sampwidth / incno;
                    }
                    else if (bodyWidth >= 992) {
                        incno = itemsSplit[2];
                        itemWidth = sampwidth / incno;
                    }
                    else if (bodyWidth >= 768) {
                        incno = itemsSplit[1];
                        itemWidth = sampwidth / incno;
                    }
                    else {
                        incno = itemsSplit[0];
                        itemWidth = sampwidth / incno;
                    }


                    $(this).css({ 'transform': 'translateX(0px)', 'width': itemWidth * itemNumbers });
                    $(this).find(itemClass).each(function () {
                        $(this).outerWidth(itemWidth);
                    });

                    $('.leftLst').addClass('over');
                    $('.rightLst').removeClass('over');

                });
            }


            //this function used to move the items
            function ResCarousel(e, el, s) {
                var leftBtn = ('.leftLst');
                var rightBtn = ('.rightLst');
                var translateXval = 0;
                var divStyle = $(el + ' ' + itemsDiv).css('transform');
                var values = divStyle.match(/-?[\d\.]+/g);
                var xds = Math.abs(parseInt(values[4]));
                if (e == 0) {
                    translateXval = (xds) - (itemWidth * parseInt(s));
                    $(el + ' ' + rightBtn).removeClass('over');

                    if (translateXval <= itemWidth / 2) {
                        translateXval = 0;
                        $(el + ' ' + leftBtn).addClass('over');
                    }
                }
                else if (e == 1) {
                    var itemsCondition = $(el).find(itemsDiv).width() - $(el).width();
                    translateXval = (xds) + (itemWidth * parseInt(s));
                    $(el + ' ' + leftBtn).removeClass('over');

                    if (translateXval >= itemsCondition - itemWidth / 2) {
                        translateXval = itemsCondition;
                        $(el + ' ' + rightBtn).addClass('over');
                    }
                }
                $(el + ' ' + itemsDiv).css('transform', 'translateX(' + -translateXval + 'px)');
            }

            //It is used to get some elements from btn
            function click(ell, ee) {
                var Parent = '#' + $(ee).parent().attr('id');
                var slide = $(Parent).attr('data-slide');
                ResCarousel(ell, Parent, slide);
            }

        });
    }
}
